"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import _ from "underscore";
import Api from "../../api/api";
import generalFormatter from "../../formatters/general";
import { getCustomerNameDisplay } from "../customerNameDisplay";
import { TableDefinition } from "../../components/table";
export const LINE_ITEM_MODE__CARRIER = "carrier";
export const LINE_ITEM_MODE__SIDE_BY_SIDE = "side-by-side";
export const LINE_ITEM_MODE__SHIPMENTS = "shipment";
class LineItemTableColumnDefinitions extends TableDefinition {
}
class ShipmentTableColumnDefinitions extends TableDefinition {
}
const LoadLineItems = React.createClass({
  getInitialState: function() {
    return {};
  },
  render: function() {
    let result;
    if (this.props.mode === LINE_ITEM_MODE__SIDE_BY_SIDE) {
      result = this.renderSideBySideLineItems();
    } else if (this.props.mode === LINE_ITEM_MODE__CARRIER) {
      result = this.renderLineItems();
    } else if (this.props.mode === LINE_ITEM_MODE__SHIPMENTS) {
      result = this.renderShipments();
    }
    return result || /* @__PURE__ */ React.createElement("span", null);
  },
  renderSideBySideLineItems: function() {
    const shipments = this.props.shipments.filter(
      (shipment) => shipment.line_items && shipment.line_items.length > 0
    );
    const hasShipments = this.props.lineItemsLoaded && shipments.length > 0;
    let shipmentLineItems = /* @__PURE__ */ React.createElement("div", { "data-component": "LoadLineItems" });
    if (hasShipments) {
      shipmentLineItems = /* @__PURE__ */ React.createElement("div", { className: "line-item-table-section" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__line-item-section-name" }, "Customer line items"), _.map(
        shipments,
        (x) => this.renderShipmentLineItemsContent(x, true)
      ));
    }
    if (this.props.lineItemsLoaded && this.props.lineItems.length > 0) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__line-item-table-container" }, shipmentLineItems, /* @__PURE__ */ React.createElement("div", { className: "line-item-table-section" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__line-item-section-name" }, "Carrier line items"), this.carrierLineItemTablesForAllCarriers()));
    }
  },
  renderLineItems: function() {
    const lineItems = this.props.lineItems;
    if (this.props.lineItemsLoaded && lineItems.length > 0) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, this.carrierLineItemTablesForAllCarriers()));
    }
  },
  carrierLineItemTablesForAllCarriers() {
    const lineItemsByCarrierId = _.groupBy(
      this.props.lineItems,
      (x) => x.tms_carrier_id
    );
    const carrierPayablesByCarrierId = _.groupBy(
      this.props.load.load.tms_carrier_payables,
      (x) => x.tms_carrier_id
    );
    const currencyFromLoad = this.props.load.load.currency || this.props.load.load.carrier_currency;
    const hasUnknownCarriers = !!(lineItemsByCarrierId["null"] && lineItemsByCarrierId["null"].length) || !!(carrierPayablesByCarrierId["null"] && carrierPayablesByCarrierId["null"].length);
    const unknownCarriers = hasUnknownCarriers ? [null] : [];
    const lineItemTables = _.chain(
      this.props.lineItemCarriers.concat(unknownCarriers)
    ).map((carrier) => {
      const carrierId = carrier && carrier.id;
      const lineItemsForCarrier = lineItemsByCarrierId[carrierId || "null"];
      const lineItemsByCarrierPayableId = _.groupBy(
        lineItemsForCarrier,
        (x) => x.tms_carrier_payable_id
      );
      const carrierPayablesForCarrier = carrierPayablesByCarrierId[carrierId || "null"] || [];
      return _.chain([
        ...carrierPayablesForCarrier,
        // include case for null carrier payable to render line items without a carrier payable.
        null
      ]).map(
        (tmsCarrierPayable) => {
          const forCarrierOnInvoice = this.props.invoice && carrier && this.props.invoice.carrier_id === carrierId;
          const forCarrierPayableOnInvoice = this.props.invoice && tmsCarrierPayable && this.props.invoice.id === tmsCarrierPayable.carrier_invoice_id;
          const lineItems = lineItemsByCarrierPayableId[tmsCarrierPayable && tmsCarrierPayable.id || "null"];
          return {
            carrier,
            tmsCarrierPayable,
            lineItems,
            forCarrierOnInvoice,
            forCarrierPayableOnInvoice,
            sortData: [
              //prioritize the carrier payable associated to the viewed invoice
              !forCarrierPayableOnInvoice,
              //prioritize line items for the invoice's carrier first
              !forCarrierOnInvoice,
              tmsCarrierPayable && tmsCarrierPayable.external_id
            ],
            currency: tmsCarrierPayable && tmsCarrierPayable.currency || currencyFromLoad,
            total: this.calculateTotalOfLineItems(lineItems)
          };
        }
      ).filter((x) => x.tmsCarrierPayable || _.some(x.lineItems)).sortBy((x) => x.sortData).value();
    }).flatten().value();
    return lineItemTables.map(
      (tableData) => this.carrierLineItemsTable(tableData)
    );
  },
  carrierLineItemsTable(tableData) {
    const carrier = tableData.carrier;
    const tmsCarrierPayable = tableData.tmsCarrierPayable;
    const lineItems = _.sortBy(tableData.lineItems, (li) => {
      return li.data.from_adjustment_price_sheet;
    }).reverse();
    const hasCarrierPayable = !!(tmsCarrierPayable && tmsCarrierPayable.id);
    function makeLinkedIndicator() {
      if (!hasCarrierPayable) {
        return null;
      } else if (tmsCarrierPayable.carrier_invoice_id) {
        return /* @__PURE__ */ React.createElement("div", { title: "Carrier Payable has Documents" }, /* @__PURE__ */ React.createElement(
          "span",
          {
            className: "icon icon-checkmark-circle-green icon--no-repeat icon--sm mr-1"
          }
        ), /* @__PURE__ */ React.createElement("span", null, "Documents"));
      } else {
        return /* @__PURE__ */ React.createElement("div", { title: "Carrier Payable does not have Documents" }, /* @__PURE__ */ React.createElement(
          "span",
          {
            className: "icon icon-alert icon--no-repeat icon--sm  mr-1"
          }
        ), /* @__PURE__ */ React.createElement("span", null, "Documents"));
      }
    }
    function makeCurrentPayableIndicator() {
      if (tableData.forCarrierPayableOnInvoice) {
        return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
          "span",
          {
            className: "icon icon-yellow-dot icon--no-repeat icon--sm mr-1"
          }
        ), /* @__PURE__ */ React.createElement("span", null, "Now viewing"));
      } else {
        return null;
      }
    }
    const carrierPayableStatusPill = hasCarrierPayable && this.pill(tmsCarrierPayable.status, "Carrier Payable Status in TMS") || null;
    const carrierId = carrier && carrier.id;
    const cols = this.columnSettings(lineItems);
    const carrierName = carrier && carrier.name || "Unknown Carrier";
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: `carrier-line-items-${carrierId}-carrier-payable-id-${tmsCarrierPayable && tmsCarrierPayable.id}`,
        className: "load-detail__line-item-table"
      },
      /* @__PURE__ */ React.createElement("div", { className: "load-detail__line-item-table-title" }, /* @__PURE__ */ React.createElement("h4", { className: "load-detail__line-item-table-subtitle" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__line-item-carrier-name" }, "Carrier name: ", carrierName), hasCarrierPayable && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "load-detail__line-item__carrier-payable-details"
        },
        makeLinkedIndicator(),
        makeCurrentPayableIndicator(),
        carrierPayableStatusPill
      ))),
      cols.renderTable(lineItems, tableData)
    );
  },
  columnSettings(lineItems) {
    const component = this;
    const showCustomerTotal = _.some(
      lineItems,
      (li) => parseFloat(li.customer_total)
    );
    const account = Api.Account.current();
    const withRateDetail = account && account.tms === "MercuryGate";
    const showRateQualifier = withRateDetail;
    const showQuantityAndRate = withRateDetail || this.isSideBySideLineItemsUxImprovementsEnabled();
    const sideBySideEnabled = this.isSideBySideLineItemsUxImprovementsEnabled();
    return new LineItemTableColumnDefinitions(this, {
      tableClasses: "load-detail__info-table",
      headerRowClasses: "load-detail__info-table-header",
      rowKeyFn: (lineItem) => `load_detail_data_row_${lineItem.id}`,
      renderSummary: this.isSideBySideLineItemsUxImprovementsEnabled(),
      emptyRowMessage: "No line items yet for this carrier payable",
      columns: [
        {
          title: "Description",
          render(lineItem) {
            return lineItem.description;
          },
          renderSummary() {
            return /* @__PURE__ */ React.createElement("b", null, "Total");
          }
        },
        {
          title: "Rate Qualifier",
          hidden: !showRateQualifier,
          render(lineItem) {
            return lineItem.rate_qualifier;
          }
        },
        {
          title: "Quantity",
          hidden: !showQuantityAndRate,
          render(lineItem) {
            return lineItem.quantity;
          }
        },
        {
          title: "Rate",
          hidden: !showQuantityAndRate,
          render(lineItem) {
            return generalFormatter.currency(lineItem.rate);
          },
          renderSummary(summaryContext) {
            return component.pill(summaryContext.currency, "Currency");
          }
        },
        {
          title: sideBySideEnabled ? "Total" : "Carrier Charge",
          render(lineItem) {
            return generalFormatter.currency(lineItem.total);
          },
          renderSummary(summaryContext) {
            return generalFormatter.currency(summaryContext.total);
          }
        },
        {
          title: "Customer Charge",
          hidden: !showCustomerTotal,
          render(lineItem) {
            return generalFormatter.currency(lineItem.customer_total);
          }
        }
      ]
    });
  },
  shipmentColumnSettings() {
    const component = this;
    return new ShipmentTableColumnDefinitions(this, {
      tableClasses: "load-detail__info-table",
      headerRowClasses: "load-detail__info-table-header",
      rowKeyFn: (lineItem) => `shipment_line_item_detail_data_row_${lineItem.id}`,
      renderSummary: this.isSideBySideLineItemsUxImprovementsEnabled(),
      columns: [
        {
          title: "Description",
          render(shipmentLineItem) {
            return shipmentLineItem.description;
          },
          renderSummary() {
            return /* @__PURE__ */ React.createElement("b", null, "Total");
          }
        },
        {
          title: "Quantity",
          render(shipmentLineItem) {
            return shipmentLineItem.quantity;
          }
        },
        {
          title: "Rate",
          render(shipmentLineItem) {
            return generalFormatter.currency(shipmentLineItem.rate);
          },
          renderSummary(summaryContext) {
            return component.pill(summaryContext.currency, "Currency");
          }
        },
        {
          title: "Total",
          render(shipmentLineItem) {
            return generalFormatter.currency(shipmentLineItem.total);
          },
          renderSummary(summaryContext) {
            return generalFormatter.currency(summaryContext.total);
          }
        }
      ]
    });
  },
  renderShipments: function() {
    if (Api.Account.shouldDisplayShipmentLineItems() && this.props.lineItemsLoaded && this.props.shipments.length > 0) {
      return /* @__PURE__ */ React.createElement("div", null, _.map(this.props.shipments, this.renderShipmentLineItems));
    }
  },
  renderShipmentLineItems: function(shipment) {
    if (shipment.line_items && shipment.line_items.length > 0) {
      return /* @__PURE__ */ React.createElement("div", { key: `shipment-line-items-${shipment.id}`, className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, this.renderShipmentLineItemsContent(shipment, false)));
    }
  },
  renderShipmentLineItemsContent: function(shipment, omitShipmentDescriptorInTitle) {
    const cols = this.shipmentColumnSettings();
    const customerNameDisplay = shipment.customer ? getCustomerNameDisplay(
      shipment.customer.name,
      shipment.customer.external_id
    ) : null;
    const shipmentData = __spreadProps(__spreadValues({}, shipment), {
      total: this.calculateTotalOfLineItems(shipment.line_items),
      currency: shipment.customer_currency
    });
    return /* @__PURE__ */ React.createElement("div", { key: "shipment-line-items-" + shipment.id }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__line-item-table-title" }, /* @__PURE__ */ React.createElement("h4", { className: "load-detail__line-item-table-subtitle" }, customerNameDisplay && /* @__PURE__ */ React.createElement("div", { className: "load-detail__line-item-customer-name" }, "Customer name: ", customerNameDisplay), /* @__PURE__ */ React.createElement("div", { className: "load-detail__line-item-external-id" }, "Order ID: ", shipment.external_id))), cols.renderTable(shipment.line_items, shipmentData));
  },
  calculateTotalOfLineItems: function(lineItems) {
    return _.chain(lineItems).map((x) => parseFloat(x.total) || 0).reduce((memo, num) => memo + num, 0).value();
  },
  isSideBySideLineItemsUxImprovementsEnabled: function() {
    return Api.Account.currentSettings().side_by_side_line_items_ux_improvements_enabled;
  },
  pill(text, title) {
    if (text) {
      return /* @__PURE__ */ React.createElement("span", { className: "carrier-labels__label", title }, text);
    }
  }
});
export default LoadLineItems;
